import { Component, Input, DestroyRef, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { GtErrorResponse } from '../../../../core/models/GtErrorResponse';
import { TokenStatus } from '../../../../core/models/TokenStatus';
import { LoginService } from '../../../../core/services/login.service';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'error-state',
    templateUrl: 'reset-pwd-error-state.component.html',
    styleUrls: ['reset-pwd-error-state.component.scss'],
    imports: [NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault]
})

export class ResetPwdErrorStateComponent {

  @Input()
  public invalidTokenInfo: GtErrorResponse;

  @Input()
  public tokenStatus = TokenStatus;

  @Input()
  public domainName = '';

  @Input()
  public guid = '';

  public regeneratedResetMsg = null;
  public emoji = '&#128521;';
  private destroyRef = inject(DestroyRef);

  constructor(private loginService: LoginService,
              private cookieService: CookieService) {
  }

  public get isValidLink(): boolean {
    if (!this.invalidTokenInfo) {
      return;
    }
    return this.invalidTokenInfo.status === TokenStatus.LINK_EXPIRE;
  }

  public reconstructPwdLink() {
    this.loginService.resendPwdLink(this.guid, this.domainName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.resendPwdLinkSubscriber.bind(this), this.resendPwdLinkErrorSubscriber.bind(this));
  }


  public returnToLogin() {
    const oAuthRequestedDomain = this.cookieService.get('OAUTH_REQUESTED_DOMAIN');
    window.location.href = oAuthRequestedDomain;
  }

  private resendPwdLinkSubscriber(res) {
    this.regeneratedResetMsg = res.message;
  }

  private resendPwdLinkErrorSubscriber(err) {
    const {error} = err;
    if (!error) {
      return;
    }
    error.status = err.status;
    this.invalidTokenInfo = error;
  }
}
